{
  "version": 1,
  "asset_id": "4977bbe0-c4fa-4596-bb10-510ecfa2dd36",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4977bbe0-c4fa-4596-bb10-510ecfa2dd36/sleeve-gastrectomy.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4977bbe0-c4fa-4596-bb10-510ecfa2dd36/sleeve-gastrectomy.jpg",
  "original_filename": "sleeve-gastrectomy.jpg",
  "size": 60297,
  "content_type": "image/jpeg",
  "created_at": "2026-07-25T17:39:25Z"
}
